import { Box, styled } from "@mui/material";

export const LeftStickyBox = styled(Box)(({ theme }) => ({
    display: "flex",
    position: "sticky", 
    left: 0, 
    backgroundColor: theme.palette.background.paper,
    boxShadow: `2px 0 4px -2px ${theme.palette.grey[300]}`,
    minWidth: "50px", 
    width: "50px",
    maxWidth: "50px"
}));

export const RightStickyBox = styled(Box)(({ theme }) => ({
    display: "flex", 
    position: "sticky", 
    right: 0, 
    background: theme.palette.background.paper, 
    boxShadow: `-2px 0 4px -2px ${theme.palette.grey[300]}` 
}));